<template>
  <div class="login_wrapper">
    <div class="login_contanier">
      <div class="login_top">
        <div class="login_logo"></div>
      </div>
      <div class="login_wrap">
        <div class="login_left_wrap vam pl50">
          <div class="txt1">HUckleberry 3.0</div>
          <div class="txt2">sign in</div>
          <!-- <div class="login_com"></div> -->
          <div class="login_car"></div>
        </div>
        <div class="login_right_wrap">
          <div class="login_text">
            {{userName}} <span>님</span>
            <p>비밀번호를 변경해 주세요.</p>
          </div>
          <div class="login_id_form">
            <div class="login_id">
              <input type="password" name="현재 비밀번호"  placeholder="현재 비밀번호" v-model="form.curentPassword" v-validate="'required'">
              <div class="lo_validation" v-if="errors.has('현재 비밀번호')">
                <div class="lo_tri"></div>
                  <span>{{ errors.first('현재 비밀번호') }}</span>
              </div>                               
            </div>
            <div class="login_id">
              <input type="password" name="변경 비밀번호" placeholder="변경 비밀번호" v-model="form.updatePassword" v-validate="'required|min:8|max:20|password'">
              <div class="lo_validation top_02" v-if="errors.has('변경 비밀번호')">
                <div class="lo_tri"></div>
                  <span>{{ errors.first('변경 비밀번호') }}</span>
              </div>                                             
            </div>
            <div class="login_pw">
              <input type="password" name="확인 비밀번호" placeholder="비밀번호 확인" v-model="form.confirmPassword" v-validate="'required|confirmed:변경 비밀번호'">
              <div class="lo_validation top_03" v-if="errors.has('확인 비밀번호')">
                <div class="lo_tri"></div>
                  <span>{{ errors.first('확인 비밀번호') }}</span>
              </div>                                                           
            </div>
          </div>
          <div class="mt10">
            <div class="login_btn">
              <button @click="updatePassword"><span>확인</span></button>
            </div>
          </div>
        </div>
      </div>
      <div class="login_footer">
        <div class="adress">
          <div class="container">
            <span class="txt">SK네트웍스(주) 서울특별시 종로구 청계천로 85 삼일빌딩</span>
            <span class="txt bl_ico">대표이사 이환용  <span class="ml10">사업자 등록번호 124-81-00718</span> <span class="ml10">전화 070-7800-2114</span></span>
            <p class="copyright">Copyright ⓒ 2017 by SK networks Co. Ltd. All Rights Reserved</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'

export default {
  name: 'password',
  data: () => ({
    form: {
      curentPassword: '',
      updatePassword: '',
      confirmPassword: ''
    }
  }),  
  computed: {
    // 사용자 이름
    userName () {
      return window.$store.getters['Login/getUserName']
    },
    roleLevel () {
      return window.$store.getters['Login/getRoleLevel']
    }    
  },  
  methods: {
    updatePassword () {
      this.$validator.validateAll()
        .then((success) => {
          if (!success) { return; }

          // 비밀번호 변경
          Vue.httpClient
          .post(AppConfig.HTTP_CONFIG.authURL + '/login/password/update', this.form)
          .then((response) => {
            if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
              Vue.Alert.alert('비밀번호 변경에 성공하였습니다.');
              this.$router.push({name: 'home'})
            } 
          })             

        });
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/Password.vue